import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { FaTachometerAlt, FaNewspaper, FaImages, FaCog } from 'react-icons/fa';
import AdminHeader from '../../components/admin/AdminHeader';
import './AdminLayout.css';

function AdminLayout() {
  return (
    <div>
      <AdminHeader />
      <div className="admin-layout">
        <aside className="admin-sidebar">
          <div className="admin-sidebar-brand">
            <span>Navigation</span>
          </div>
          <nav>
            <NavLink to="/admin" end className={({ isActive }) => isActive ? 'active' : ''}>
              <FaTachometerAlt /> Tableau de bord
            </NavLink>
            <NavLink to="/admin/articles" className={({ isActive }) => isActive ? 'active' : ''}>
              <FaNewspaper /> Articles
            </NavLink>
            <NavLink to="/admin/images" className={({ isActive }) => isActive ? 'active' : ''}>
              <FaImages /> Images
            </NavLink>
            <NavLink to="/admin/site-content" className={({ isActive }) => isActive ? 'active' : ''}>
              <FaCog /> Contenu du site
            </NavLink>
          </nav>
        </aside>
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
